import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const CanMyTeamTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentUrl = location.pathname;

  return (
    <ul className="nav nav-tabs" id="myTab" role="tablist">
      <li className="nav-item" role="presentation">
        <button
          className={
            currentUrl === "/candidate/my-teams" ||
            currentUrl === "/candidate/my-teams/"
              ? "nav-link active"
              : "nav-link"
          }
          data-bs-toggle="tab"
          data-bs-target="#sign-employees"
          type="button"
          onClick={() => navigate("/candidate/my-teams")}
        >
          <i className="fas fa-users" /> Teams
        </button>
      </li>
      <li className="nav-item" role="presentation">
        <button
          className={
            currentUrl === "/candidate/my-teams-invites" ||
            currentUrl === "/candidate/my-teams-invites/"
              ? "nav-link active"
              : "nav-link"
          }
          data-bs-toggle="tab"
          data-bs-target="#sign-trusted-workers"
          type="button"
          onClick={() => navigate("/candidate/my-teams-invites")}
        >
          <i className="fa fa-user-plus" /> Invites
        </button>
      </li>
    </ul>
  );
};

export default CanMyTeamTabs;
